export const mapConfig = {
  polygon: {
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillOpacity: 0.35,
  },
};
